(function($){
    $(function($){

        initMenuButton();
        $('#menu-trigger').on('click', function(event){
            toggleMainMenu();
        });

        $('#do-search-icon').on('click', function(e){
            $(this).parent('form').submit();
        });

        // get all stati from tool-boxes (open or closed)
        Object.keys(localStorage).map( key => {
            if (key.startsWith('map.toolBox.')) {
                const id = key.replace('map.toolBox.', '');
                initToolBox(id, localStorage[key] === 'true');
            }
        });
        window.addEventListener("resize", () => {
            initMenuButton();
        });
    })
})(jQuery);

initMenuButton = function() {
    if ($('#navigator').is(":visible")) {
        $('#menu-trigger').removeClass('closed')
    } else {
        $('#menu-trigger').addClass('closed')
    }
}

toggleMainMenu = function() {
    if ($('#navigator').is(":visible")) {
        $('#menu-trigger').addClass('closed')
        $('#navigator').hide();
    } else {
        $('#menu-trigger').removeClass('closed')
        $('#navigator').show();
    }
}

/** toolbox open and close **/
initToolBox = function(id, open) {
    const box = $('#' + id);
    if (box) {
        if (open) {
            openToolBox(box);
        } else {
            closeToolBox(box);
        }
    }
}

toggleToolBox = function(item) { // open-close of tool-box in navigator
    const box = $(item).closest('.tool-box');
    const isOpen = box.find('.tool-box-content').hasClass('open');
    if (isOpen) {
        closeToolBox(box);
    } else {
        openToolBox(box);
    }
    // all .tool-box  with this function have to define their id! See initToolBox
    localStorage.setItem('map.toolBox.' + box.attr('id'), !isOpen);  // we toggled open before
}
openToolBox = function(box) {
    box.find('.arrow .fa').hide();
    box.find('.tool-box-content').addClass('open');
    box.find('.arrow .fa-angle-up').show();
}
closeToolBox = function(box) {
    box.find('.arrow .fa').hide();
    box.find('.tool-box-content').removeClass('open')
    box.find('.arrow .fa-angle-down').show();
}


/** Navigator localStorage **/

storeLectureUrl = function(href) {
    // todo @development only: local issue with browsersync
    if (href.startsWith('//127.0.0.1')) {
        href = href.replace('//127.0.0.1', 'http://127.0.0.1');
    }
    localStorage.setItem('map.navigator.lecture.url', href);
}

storeResearchUrl = function(href) {
    // todo @development only local issue with browsersync
    if (href.startsWith('//127.0.0.1')) {
        href = href.replace('//127.0.0.1', 'http://127.0.0.1');
    }
    localStorage.setItem('map.navigator.research.url', href);
}

resetMapMode = function() {
    localStorage.removeItem('map.navigator.mode');
    localStorage.removeItem('map.navigator.mainIndex');
}
